export default "__VITE_ASSET__BGXe5l8c__"